<template>
    <section name="service" class="service_sb">
        <div class="wrapper service_content">
            <div class="service_text" :class="'text-' + content.alignment">
                <img
                    src="/svg/ic_boat.svg"
                    alt="ic_info"
                    class="star-icon mb-4"
                >
                <h2>
                    {{content.title}}
                </h2>
                <p v-html="content.content_1"></p>
                <p v-html="content.content_2"></p>
            </div>
            <span :style="!content.media ? '' : 'background: url(' + (content.media.full_url) + ')'" class="service_image"></span>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        content: {
            required: true,
        },
    },
}
</script>
